import Styles from "./fontsize.module.scss";

const FontSize = ({ setFontSize, fontSize }) => {
  const handleFS = (size) => {
    if (window && window.localStorage !== undefined) {
      if (size) {
        localStorage.removeItem("fontSize");
        localStorage.setItem("fontSize", size);
        setFontSize(size);
      }
    }
  };

  return (
    <div title="Font Size" className={Styles["dropdown"]}>
      <div role={"button"} className={Styles["dropbtn"]}>
        <img
          height="22px"
          width="22px"
          src="/assets/images/font-size.png"
          style={{ height: "22px", marginBottom: "4px" }}
          alt="font-size"
        />
      </div>
      <div className={Styles["dropdown-content"]}>
        <div
          style={fontSize == "small" ? { backgroundColor: "#f1f1f1" } : {}}
          onClick={() => handleFS("small")}
          role={"button"}
        >
          Small
        </div>
        <div
          style={fontSize == "normal" ? { backgroundColor: "#f1f1f1" } : {}}
          onClick={() => handleFS("normal")}
          role={"button"}
        >
          Medium
        </div>
        <div
          style={fontSize == "large" ? { backgroundColor: "#f1f1f1" } : {}}
          onClick={() => handleFS("large")}
          role={"button"}
        >
          Large
        </div>
      </div>
    </div>
  );
};

export default FontSize;
